import styled from "@emotion/styled";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DoubleCol = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const SizeInputWrapper = styled.div`
  position: relative;
  padding-bottom: 5px;
  width: 100%;
`;

export const SizeInputIcon = styled.span`
  position: absolute;
  left: 15px;
  top: 7px;
  width: 20px;
  text-align: center;
  color: grey;
  i {
    font-size: 12px;
  }
`;

export const SizeInput = styled.input`
  width: 100%;
  border: none;
  background-color: #f4f4f4;
  border-radius: 0.875rem;
  height: 40px;
  padding-left: 40px;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 500;
`;

export const ColumnWrapper = styled.div`
  width: 100%;
  display: block;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const SliderWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SliderIcon = styled.span`
  color: grey;
  font-size: 12px;
  margin-right: 10px;
  width: 0px;
`;

export const ResetButton = styled.button`
  width: 30px;
  padding: 0px;
  border: none;
  background: none;
  color: grey;
  i {
    font-size: 18px;
  }
`;
